import React, { useState, useEffect } from 'react';
import { MapPin } from 'lucide-react';
import {
    Wrapper, Card, Header, LeftSection, LocationIcon, Divider,
    Brand, CenterTitle, DropdownWrapper, Dropdown, ChevronIcon,
    StatsGrid, StatCard, Label, ValueRow, Value, Percent, Unit,
    ChartWrapper, ChartCard, ChartTitle
} from './dashborad-dealer_styles';

import { ApiURLs, webSiteUrl } from '../../constant/ApiUrls';
import { fetchData } from '../../services/api';
import { cur } from '../../constant/Constants';






import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    BarChart,
    Bar,
    // PieChart,
    // Pie,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
    // Cell,
    // Legend
} from 'recharts';



// const COLORS = [
//     '#0088FE', // blue
//     '#00C49F', // green
//     '#FFBB28', // yellow-orange
//     '#FF8042', // orange
//     '#AF19FF', // purple
//     '#FF4C4C', // red
//     '#1E90FF', // dodger blue
//     '#32CD32', // lime green
//     '#FFD700', // gold
//     '#8A2BE2'  // blue violet
// ];


const DashboardDealer = () => {
    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 21 }, (_, i) => currentYear - i);

    // const getColor = (value) => {
    //     if (value >= 50) return '#216e39';
    //     if (value >= 25) return '#60bd68';
    //     if (value >= 10) return '#c6e48b';
    //     if (value > 0) return '#ebedf0';
    //     return '#f0f0f0'; // 0% retention
    // };

    const filterLIst = [
        <option value="monthly">Monthly</option>,
        <option value="weekly">Weekly</option>,
        <option value="daily">Daily</option>,
    ];

    const filterLIstNew = [
        <option value="monthly">Monthly</option>,
        <option value="weekly">Weekly</option>,
    ];

    const monthList = [
        <option value="1">January</option>,
        <option value="2">February</option>,
        <option value="3">March</option>,
        <option value="4">April</option>,
        <option value="5">May</option>,
        <option value="6">June</option>,
        <option value="7">July</option>,
        <option value="8">August</option>,
        <option value="9">September</option>,
        <option value="10">October</option>,
        <option value="11">November</option>,
        <option value="12">December</option>,

    ];

    const [selectedYear, setSelectedYear] = useState(currentYear);


    const [stats, setStats] = useState(null);
    const [user, setUser] = useState('monthly');
    const [userMonth, setUserMonth] = useState('1');



    const [revenue, setRevenue] = useState('monthly');
    const [revenueMonth, setRevenueMonth] = useState('1');


    const [adSell, setAdSell] = useState('monthly');
    const [adSellMonth, setAdSellMonth] = useState('1');




    const [block, setBlock] = useState('monthly');
    const [blockMonth, setBlockMonth] = useState('1');


    const [report, setReport] = useState('monthly');
    const [reportMonth, setReportMonth] = useState('1');


    // const [spotlightBump, setSpotlightBump] = useState('monthly');
    // const [spotlightBumpMonth, setSpotlightBumpMonth] = useState('1');

    // const [sell, setSell] = useState('monthly');
    // const [sellMonth, setSellMonth] = useState('1');



    // const CohortHeatmap = ({ data }) => {

    //     console.log('dataatata;;;;;;', data);
    //     if (!Array.isArray(data) || data.length === 0) {
    //         return <div>No data available</div>;
    //     }

    //     const maxDays = Math.max(
    //         ...data.map(d => (Array.isArray(d.retention) ? d.retention.length : 0))
    //     );

    //     return (
    //         <div>
    //             <h2 style={{ textAlign: 'left', marginBottom: '1rem' }}>Cohort Heatmap Retention</h2>

    //             <div style={{ overflowX: 'auto' }}>
    //                 <table style={{ borderCollapse: 'collapse', width: '100%' }}>
    //                     <thead>
    //                         <tr>
    //                             <th style={{ padding: '8px', border: '1px solid #ccc', backgroundColor: '#f7f7f7', textAlign: 'left' }}>Signup Week</th>
    //                             {[...Array(maxDays)].map((_, i) => (
    //                                 <th key={i} style={{ padding: '4px', border: '1px solid #ccc', backgroundColor: '#f7f7f7', fontSize: '12px' }}>
    //                                     Day {i + 1}
    //                                 </th>
    //                             ))}
    //                         </tr>
    //                     </thead>
    //                     <tbody>
    //                         {data.map((weekData, rowIndex) => (
    //                             <tr key={rowIndex}>
    //                                 <td style={{ padding: '8px', border: '1px solid #ccc', fontWeight: 'bold' }}>{weekData.week}</td>
    //                                 {[...Array(maxDays)].map((_, dayIndex) => {
    //                                     const value = weekData.retention?.[dayIndex] ?? 0;
    //                                     return (
    //                                         <td
    //                                             key={dayIndex}
    //                                             style={{
    //                                                 padding: '0',
    //                                                 height: '30px',
    //                                                 width: '30px',
    //                                                 border: '1px solid #ccc',
    //                                                 backgroundColor: getColor(value),
    //                                                 textAlign: 'center',
    //                                                 fontSize: '12px',
    //                                                 color: value > 0 ? '#fff' : '#888'
    //                                             }}
    //                                             title={`${value}% retained`}
    //                                         >
    //                                             {value}%
    //                                         </td>
    //                                     );
    //                                 })}
    //                             </tr>
    //                         ))}
    //                     </tbody>
    //                 </table>
    //             </div>
    //         </div>
    //     );
    // };


    useEffect(() => {
        const getDashboardStats = async (year) => {



            const url = `${ApiURLs.DASHBOARD_DEALER}?year=${year}&user=${user}&userMonth=${userMonth}&revenue=${revenue}&revenueMonth=${revenueMonth}&adSell=${adSell}&adSellMonth=${adSellMonth}&block=${block}&blockMonth=${blockMonth}&report=${report}&reportMonth=${reportMonth}`;
            try {
                const response = await fetchData(url);
                if (response.status === 1) {
                    setStats(response.data);
                } else {
                    setStats(null);
                }
            } catch (error) {
                console.error('Error fetching dashboard stats:', error);
                setStats(null);
            }





            const urlAnalysis = `${ApiURLs.ANALYSIS}`;
            try {
                const response = await fetchData(urlAnalysis);
                if (response.status === 1) {
                    console.log("HSHSHJS,", response)
                    // setAnalysis(response);
                } else {
                    // setAnalysis(null);
                }
            } catch (error) {
                console.error('Error fetching dashboard analysis:', error);
                // setAnalysis(null);
            }
        };
        getDashboardStats(selectedYear);
    }, [selectedYear, user, userMonth, revenue, revenueMonth, adSell, adSellMonth, block, blockMonth, report, reportMonth, ]);

    const formatGrowth = (growth) => {
        const value = parseFloat(growth);
        if (isNaN(value)) return '—';
        const sign = value > 0 ? '+' : '';
        return `${sign}${value}%`;
    };

    const isPositive = (growth) => parseFloat(growth) >= 0;



    return (
        <Wrapper>
            <Card>
                <Header>
                    <LeftSection>
                        <LocationIcon>
                            <MapPin size={24} color="#2563eb" />
                        </LocationIcon>
                        <Brand>{webSiteUrl}</Brand>
                    </LeftSection>

                    <CenterTitle>Dealers Dashboard</CenterTitle>

                    <DropdownWrapper>
                        <Dropdown
                            value={selectedYear}
                            onChange={(e) => setSelectedYear(Number(e.target.value))}
                        >
                            {years.map((year) => (
                                <option key={year} value={year}>
                                    {year}
                                </option>
                            ))}
                        </Dropdown>
                        <ChevronIcon size={16} />
                    </DropdownWrapper>
                </Header>

                <Divider />

                <StatsGrid>



                    <StatCard>
                        <Label>Daily Active Dealers</Label>
                        <ValueRow>
                            <Value>{stats ? stats.dailyActiveUsers : '—'}</Value>
                            <Percent positive={isPositive(stats?.dailyActiveUsersGrowth)}>
                                {stats ? formatGrowth(stats.dailyActiveUsersGrowth) : '—'}
                            </Percent>
                        </ValueRow>
                    </StatCard>






                    <StatCard>
                        <Label>New Dealers In Last 7 Days</Label>
                        <ValueRow>
                            <Value>{stats ? stats.newUsers7 : '—'}</Value>
                            <Percent positive={isPositive(stats?.newUsersGrowth7)}>
                                {stats ? formatGrowth(stats.newUsersGrowth7) : '—'}
                            </Percent>
                        </ValueRow>
                    </StatCard>


                    <StatCard>
                        <Label>New Dealers In Last 30 Days</Label>
                        <ValueRow>
                            <Value>{stats ? stats.newUsers30 : '—'}</Value>
                            <Percent positive={isPositive(stats?.newUsersGrowth30)}>
                                {stats ? formatGrowth(stats.newUsersGrowth30) : '—'}
                            </Percent>
                        </ValueRow>
                    </StatCard>


                    <StatCard>
                        <Label>New Dealers In {selectedYear}</Label>
                        <ValueRow>
                            <Value>{stats ? stats.newUsers : '—'}</Value>
                            <Percent positive={isPositive(stats?.newUsersGrowth)}>
                                {stats ? formatGrowth(stats.newUsersGrowth) : '—'}
                            </Percent>
                        </ValueRow>
                    </StatCard>


                    <StatCard>
                        <Label>All Dealers</Label>
                        <ValueRow>
                            <Value>{stats ? stats.totalUsers : '—'}</Value>
                        </ValueRow>
                    </StatCard>


                    <StatCard>
                        <Label>All Blocked Dealers</Label>
                        <ValueRow>
                            <Value>{stats ? stats.blockUsers : '—'}</Value>
                        </ValueRow>
                    </StatCard>

                    <StatCard>
                        <Label>Ads Sold by Dealers in {selectedYear}</Label>
                        <ValueRow>
                            <Value>{stats ? stats.soldAds : '—'}</Value>
                            <Percent positive={isPositive(stats?.soldAdsGrowth)}>
                                {stats ? formatGrowth(stats.soldAdsGrowth) : '—'}
                            </Percent>
                        </ValueRow>
                    </StatCard>



                    <StatCard>
                        <Label>Avg. Sell Time (Dealers) In {selectedYear}</Label>
                        <ValueRow>
                            <Value>{stats ? stats.avgSellTime : '—'}</Value>
                            <Unit>days</Unit>
                        </ValueRow>
                    </StatCard>




                    <StatCard>
                        <Label>All Ads Sold by Dealers</Label>
                        <ValueRow>
                            <Value>{stats ? stats.totalSoldAds : '—'}</Value>
                        </ValueRow>
                    </StatCard>

                    <StatCard>
                        <Label>Revenue From Dealers In {selectedYear}</Label>
                        <ValueRow>
                            <Value>{cur}{stats ? stats.revenue : '—'}</Value>
                            <Percent positive={isPositive(stats?.revenueGrowth)}>
                                {stats ? formatGrowth(stats.revenueGrowth) : '—'}
                            </Percent>
                        </ValueRow>
                    </StatCard>







                    <StatCard>
                        <Label>Total Revenue From Dealers</Label>
                        <ValueRow>
                            <Value>{cur}{stats ? stats.totalRevenue : '—'}</Value>
                        </ValueRow>
                    </StatCard>
                </StatsGrid>

                {/* Charts */}
                <ChartWrapper>
                    <ChartCard>
                        <ChartTitle>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                                <ChartTitle style={{ margin: 0 }}>Dealers Over Time</ChartTitle>
                                <DropdownWrapper style={{ marginLeft: 'auto' }}>
                                    <Dropdown
                                        value={user}
                                        onChange={(e) => setUser(e.target.value)}
                                        style={{ width: '120px' }}
                                    >
                                        {filterLIst}

                                    </Dropdown>
                                    <ChevronIcon size={16} />
                                </DropdownWrapper>

                                {user !== "monthly" && <DropdownWrapper style={{ marginLeft: 'auto' }}>
                                    <Dropdown
                                        value={userMonth}
                                        onChange={(e) => setUserMonth(e.target.value)}
                                        style={{ width: '120px' }}
                                    >
                                        {monthList}


                                    </Dropdown>
                                    <ChevronIcon size={16} />
                                </DropdownWrapper>}
                            </div>
                        </ChartTitle>


                        <ResponsiveContainer width="100%" height={250}>
                            <LineChart data={stats?.user_over_time || []} margin={{ top: 10, right: 0, left: 0, bottom: 5 }}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey={user} />
                                <YAxis allowDecimals={false} />
                                <Tooltip />
                                <Line type="monotone" dataKey="users" stroke="#4f46e5" strokeWidth={3} />
                            </LineChart>
                        </ResponsiveContainer>
                    </ChartCard>

                    <ChartCard>
                        <ChartTitle>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                                <ChartTitle style={{ margin: 0 }}>Revenue Over Time From Dealers</ChartTitle>
                                <DropdownWrapper style={{ marginLeft: 'auto' }}>
                                    <Dropdown
                                        value={revenue}
                                        onChange={(e) => setRevenue(e.target.value)}
                                        style={{ width: '120px' }}
                                    >
                                        {filterLIst}

                                    </Dropdown>
                                    <ChevronIcon size={16} />
                                </DropdownWrapper>

                                {revenue !== "monthly" && <DropdownWrapper style={{ marginLeft: 'auto' }}>
                                    <Dropdown
                                        value={revenueMonth}
                                        onChange={(e) => setRevenueMonth(e.target.value)}
                                        style={{ width: '120px' }}
                                    >
                                        {monthList}


                                    </Dropdown>
                                    <ChevronIcon size={16} />
                                </DropdownWrapper>}
                            </div>
                        </ChartTitle>


                        <ResponsiveContainer width="100%" height={250}>
                            <LineChart data={stats?.revenue_over_time || []} margin={{ top: 10, right: 0, left: 0, bottom: 5 }}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey={revenue} />
                                <YAxis allowDecimals={false} />
                                <Tooltip />
                                <Line type="monotone" dataKey="total" stroke="#4f46e5" strokeWidth={3} />
                            </LineChart>
                        </ResponsiveContainer>
                    </ChartCard>


                </ChartWrapper>

                <ChartWrapper>
                    <ChartCard>
                        <ChartTitle>
                            Top Sold Categories By Dealers
                        </ChartTitle>

                        <ResponsiveContainer width="100%" height={300}>
                            <BarChart
                                data={stats?.top_sold_categories || []}
                                layout="vertical"
                                margin={{ top: 10, right: 0, left: 0, bottom: 5 }}
                            >
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis type="number" allowDecimals={false} />
                                <YAxis dataKey="category_name" type="category" width={200} />
                                <Tooltip />
                                <Bar dataKey="count" fill="#3b82f6" barSize={20} />
                            </BarChart>
                        </ResponsiveContainer>
                    </ChartCard>
                </ChartWrapper>

                <ChartWrapper>




                    <ChartCard>
                        <ChartTitle>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                                <ChartTitle style={{ margin: 0 }}>Ad Placed/Sold Over Time By Dealers</ChartTitle>
                                <DropdownWrapper style={{ marginLeft: 'auto' }}>
                                    <Dropdown
                                        value={adSell}
                                        onChange={(e) => setAdSell(e.target.value)}
                                        style={{ width: '120px' }}
                                    >
                                        {filterLIst}

                                    </Dropdown>
                                    <ChevronIcon size={16} />
                                </DropdownWrapper>

                                {adSell !== "monthly" && <DropdownWrapper style={{ marginLeft: 'auto' }}>
                                    <Dropdown
                                        value={adSellMonth}
                                        onChange={(e) => setAdSellMonth(e.target.value)}
                                        style={{ width: '120px' }}
                                    >
                                        {monthList}


                                    </Dropdown>
                                    <ChevronIcon size={16} />
                                </DropdownWrapper>}
                            </div>
                        </ChartTitle>
                        <ResponsiveContainer width="100%" height={250}>
                            <LineChart data={stats?.ad_sell_over_time || []} margin={{ top: 10, right: 0, left: 0, bottom: 5 }}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey={adSell} />
                                <YAxis allowDecimals={false} />
                                <Tooltip />
                                <Line type="monotone" dataKey="adSold" stroke="#22c55e" strokeWidth={3} name="Ads Sold" />
                                <Line type="monotone" dataKey="adPlaced" stroke="#3b82f6" strokeWidth={3} name="Ads Placed" />

                            </LineChart>
                        </ResponsiveContainer>
                    </ChartCard>





                    <ChartCard>
                        <ChartTitle>
                            Top Categories In Dealers
                        </ChartTitle>

                        <ResponsiveContainer width="100%" height={300}>
                            <BarChart
                                data={stats?.top_categories || []}
                                layout="vertical"
                                margin={{ top: 10, right: 0, left: 0, bottom: 5 }}
                            >
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis type="number" allowDecimals={false} />
                                <YAxis dataKey="category_name" type="category" width={200} />
                                <Tooltip />
                                <Bar dataKey="count" fill="#3b82f6" barSize={20} />
                            </BarChart>
                        </ResponsiveContainer>
                    </ChartCard>
















                </ChartWrapper>

                <ChartWrapper>

                    <ChartCard>
                        <ChartTitle>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                                <ChartTitle style={{ margin: 0 }}>Blocked/Suspended Dealers
                                </ChartTitle>
                                <DropdownWrapper style={{ marginLeft: 'auto' }}>
                                    <Dropdown
                                        value={block}
                                        onChange={(e) => setBlock(e.target.value)}
                                        style={{ width: '120px' }}
                                    >
                                        {filterLIstNew}

                                    </Dropdown>
                                    <ChevronIcon size={16} />
                                </DropdownWrapper>

                                {block !== "monthly" && <DropdownWrapper style={{ marginLeft: 'auto' }}>
                                    <Dropdown
                                        value={blockMonth}
                                        onChange={(e) => setBlockMonth(e.target.value)}
                                        style={{ width: '120px' }}
                                    >
                                        {monthList}


                                    </Dropdown>
                                    <ChevronIcon size={16} />
                                </DropdownWrapper>}
                            </div>
                        </ChartTitle>
                        <ResponsiveContainer width="100%" height={250}>
                            <BarChart data={stats?.block_over_time || []} margin={{ top: 10, right: 0, left: 0, bottom: 5 }}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey={block} />
                                <YAxis allowDecimals={false} />
                                <Tooltip />
                                <Bar type="monotone" dataKey="users" fill="#3b82f6" />
                            </BarChart>
                        </ResponsiveContainer>
                    </ChartCard>





                    <ChartCard>
                        <ChartTitle>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                                <ChartTitle style={{ margin: 0 }}>Flagged / Reported Dealer Ads
                                </ChartTitle>
                                <DropdownWrapper style={{ marginLeft: 'auto' }}>
                                    <Dropdown
                                        value={report}
                                        onChange={(e) => setReport(e.target.value)}
                                        style={{ width: '120px' }}
                                    >
                                        {filterLIst}

                                    </Dropdown>
                                    <ChevronIcon size={16} />
                                </DropdownWrapper>

                                {report !== "monthly" && <DropdownWrapper style={{ marginLeft: 'auto' }}>
                                    <Dropdown
                                        value={reportMonth}
                                        onChange={(e) => setReportMonth(e.target.value)}
                                        style={{ width: '120px' }}
                                    >
                                        {monthList}


                                    </Dropdown>
                                    <ChevronIcon size={16} />
                                </DropdownWrapper>}
                            </div>
                        </ChartTitle>
                        <ResponsiveContainer width="100%" height={250}>
                            <LineChart data={stats?.trend_over_time || []} margin={{ top: 10, right: 0, left: 0, bottom: 5 }}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey={report} />
                                <YAxis allowDecimals={false} />
                                <Tooltip />
                                <Line
                                    type="monotone"
                                    dataKey="total"
                                    stroke="#f87171"
                                    strokeWidth={2}
                                    dot={{ r: 4 }}
                                    name="Reported Ads"
                                />

                                <Line
                                    type="monotone"
                                    dataKey="trend"
                                    stroke="#60a5fa"
                                    strokeWidth={2}
                                    strokeDasharray="5 5"
                                    dot={false}
                                    name="Trendline"
                                />                            </LineChart >
                        </ResponsiveContainer>
                    </ChartCard>

                </ChartWrapper>

                {/*   <ChartWrapper>
                    <ChartCard>
                        <ChartTitle>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                                <ChartTitle style={{ margin: 0 }}>Device Use
                                </ChartTitle>

                            </div>
                        </ChartTitle>
                        <ResponsiveContainer width="100%" height={250}>

                            <PieChart width={400} height={250}>
                                <Pie
                                    data={stats?.devices || []}
                                    dataKey="value"
                                    nameKey="name"
                                    cx="50%"
                                    cy="50%"
                                    outerRadius={80}
                                    label
                                >
                                    {(stats?.devices || []).map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                    ))}
                                </Pie>
                                <Tooltip />
                            </PieChart>

                        </ResponsiveContainer>
                        <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '1rem', justifyContent: "center" }}>
                            {(stats?.devices || []).map((entry, index) => (
                                <div key={index} style={{ display: 'flex', alignItems: 'center', marginRight: '1.5rem', marginBottom: '0.5rem' }}>
                                    <div
                                        style={{
                                            width: 12,
                                            height: 12,
                                            backgroundColor: COLORS[index % COLORS.length],
                                            marginRight: 8,
                                            borderRadius: 2,
                                        }}
                                    />
                                    <span>{entry.name}</span>
                                </div>
                            ))}
                        </div>
                    </ChartCard>



                    <ChartCard>
                        <ChartTitle>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                                <ChartTitle style={{ margin: 0 }}>Traffic Sources Slice Breakdown
                                </ChartTitle>

                            </div>
                        </ChartTitle>
                        <ResponsiveContainer width="100%" height={250}>

                            <PieChart width={400} height={250}>
                                <Pie
                                    data={analysis?.data || []}
                                    dataKey="value"
                                    nameKey="label"
                                    cx="50%"
                                    cy="50%"
                                    outerRadius={80}
                                    label
                                >
                                    {(analysis?.data || []).map((entry, index) => (
                                        <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                    ))}
                                </Pie>
                                <Tooltip />
                            </PieChart>

                        </ResponsiveContainer>


                        <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: '1rem', justifyContent: "center" }}>
                            {(analysis?.data || []).map((entry, index) => (
                                <div key={index} style={{ display: 'flex', alignItems: 'center', marginRight: '1.5rem', marginBottom: '0.5rem' }}>
                                    <div
                                        style={{
                                            width: 12,
                                            height: 12,
                                            backgroundColor: COLORS[index % COLORS.length],
                                            marginRight: 8,
                                            borderRadius: 2,
                                        }}
                                    />
                                    <span>{entry.label}</span>
                                </div>
                            ))}
                        </div>
                    </ChartCard>

                </ChartWrapper>

                <ChartWrapper>



                    <ChartCard>
                        <ChartTitle>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                                <ChartTitle style={{ margin: 0 }}>Spotlight/Bump/Subscription
                                </ChartTitle>
                                <DropdownWrapper style={{ marginLeft: 'auto' }}>
                                    <Dropdown
                                        value={spotlightBump}
                                        onChange={(e) => setSpotlightBump(e.target.value)}
                                        style={{ width: '120px' }}
                                    >
                                        {filterLIst}

                                    </Dropdown>
                                    <ChevronIcon size={16} />
                                </DropdownWrapper>

                                {spotlightBump !== "monthly" && <DropdownWrapper style={{ marginLeft: 'auto' }}>
                                    <Dropdown
                                        value={spotlightBumpMonth}
                                        onChange={(e) => setSpotlightBumpMonth(e.target.value)}
                                        style={{ width: '120px' }}
                                    >
                                        {monthList}


                                    </Dropdown>
                                    <ChevronIcon size={16} />
                                </DropdownWrapper>}
                            </div>
                        </ChartTitle>

                        <ResponsiveContainer width="100%" height={300}>
                            <BarChart data={stats?.spotlight_bump_over_time || []} margin={{ top: 10, right: 20, left: 0, bottom: 5 }}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey={spotlightBump} />
                                <YAxis allowDecimals={false} />
                                <Tooltip />
                                <Legend />
                                <Bar dataKey="spotlight_ad_count" fill="#3b82f6" name="Spotlight Ads" />
                                <Bar dataKey="bump_ad_count" fill="#10b981" name="Bump Ads" />
                            </BarChart>
                        </ResponsiveContainer>


                    </ChartCard>
                </ChartWrapper>

                <ChartWrapper>

                    <ChartCard>
                        <ChartTitle>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1rem' }}>
                                <ChartTitle style={{ margin: 0 }}>Heat Map</ChartTitle>
                            </div>
                        </ChartTitle>

                        <CohortHeatmap data={stats?.retention_map || []} />

                    </ChartCard>


                </ChartWrapper>
 */}




            </Card>
        </Wrapper>
    );
};

export default DashboardDealer;
